import { IconButton } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import React, { useState } from "react";
import { Row, Col, Input, InputGroup, InputGroupAddon, InputGroupText, ModalBody,
  Modal,
  ModalFooter,
  ModalHeader } from "reactstrap";
import moment from 'moment';
import { isEmpty, size, isUndefined, filter } from "lodash";
import Button from "@material-ui/core/Button";
import { successDescriptionOptionsData,deleteCommunityAssetsCall} from "../community-property/communityProperty.actions";
import { connect } from "react-redux";
function CommunityPropertySection(props) {
  const [inputFields, setInputField] = useState(props.data);

  const [showNote, setShowNote] = useState(false);
  const handleShowNote = () => setShowNote(true);
  const handleCloseNote = () => setShowNote(false);

  const handleChangeInput = (index, event) => {
    const values = [...inputFields];
    values[index][event.target.id] = event.target.value;
    setInputField(values);

  }

  const handleAddFields = () => {
    setInputField([...inputFields, { brief_desc: "", date_acquired: "", gfmv: "0.0", aod: "0.0", nfmv: "0.0", pfdp: "0.0", pfdr: "0.0" }])
  }

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    if (index = 1)
      values.splice(index, 1);
    setInputField(values);
  }

  console.log(props.data, "props");
  console.log(inputFields, "inputfield")


  const ColoredLine = ({ color }) => (
    <hr
      style={{
        borderTop: "2px solid",
        color: "black",
      }}
    />
  );

  const deleteCall = (id, description, descriptionId) => {
    props.deleteCommunityAssetsCall({
      divorce_id: window.localStorage.getItem("divorce_id"),
      form_160_asset_id: isUndefined(id) ? filter(props.data, x => x.brief_desc === description)[0].form_160_asset_id : id,
      asset_brief_description_id: isUndefined(descriptionId) ? filter(props.data, x => x.brief_desc === description)[0].asset_brief_description_id : descriptionId,
      propertyType: 1,
    })
  }

  const getButtonValue = (e, size) => {
    switch (e) {
      case 1:
        return size < 2 ? true : false;
      case 2:
        return size < 5 ? true : false;
      case 3:
        return size < 3 ? true : false;
      case 4:
        return size < 3 ? true : false;
      case 5:
        return size < 3 ? true : false;
      case 6:
        return size < 3 ? true : false;
      case 7:
        return size < 3 ? true : false;
      case 8:
        return size < 2 ? true : false;
      case 9:
        return size < 2 ? true : false;
      case 10:
        return size < 2 ? true : false;
      case 11:
        return size < 3 ? true : false;
      case 12:
        return size < 3 ? true : false;
      case 13:
        return size < 3 ? true : false;
      case 14:
        return size < 3 ? true : false;
      case 15:
        return size < 3 ? true : false;
      case 16:
        return size < 3 ? true : false;

      default:
        return false;
    }
  }

  const showModal = (e, size) => {
    switch (e) {
      case 1:
        if(size === 1){
          handleShowNote()
        }
        break;
      case 2:
      if(size === 4){
          handleShowNote()
        }
        break;
      case 3:
      if(size === 2){
          handleShowNote()
        }
        break;
      case 4:
      if(size === 2){
          handleShowNote()
        }
        break;
      case 5:
      if(size === 2){
          handleShowNote()
        }
        break;
      case 6:
      if(size === 2){
          handleShowNote()
        }
        break;
      case 7:
      if(size === 2){
          handleShowNote()
        }
        break;
      case 8:
      if(size === 1){
          handleShowNote()
        }
        break;
      case 9:
      if(size === 1){
          handleShowNote()
        }
        break;
      case 10:
      if(size === 1){
          handleShowNote()
        }
        break;
      case 11:
      if(size === 2){
          handleShowNote()
        }
        break;
      case 12:
      if(size === 2){
          handleShowNote()
        }
        break;
      case 13:
      if(size === 2){
          handleShowNote()
        }
        break;
      case 14:
      if(size === 2){
          handleShowNote()
        }
        break;
      case 15:
      if(size === 2){
          handleShowNote()
        }
        break;
      case 16:
      if(size === 2){
          handleShowNote()
        }
        break;

      default:
        return false;
    }
  }


  return (
    <div>
      {!isEmpty(inputFields) && inputFields.map((inputF, index) => (

        <div key={index} >


          <Row>
            <Col xl={6}>
              <b>Brief Description:</b>
            </Col>
            <Col xl={12}>
              <Input style={{ marginLeft: "2px" }} defaultValue={inputF.brief_desc} type="text" id="brief_desc"
                onBlur={(e) => { props.handleDescriptionChange(inputFields); handleChangeInput(index, e) }} />
            </Col>
          </Row>

          <Row>
            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <br></br>
              <b>Date Acquired:</b>

              <Input defaultValue={(inputF.date_acquired == "1947-01-01") ? "" : moment(inputF.date_acquired).format('YYYY-MM-DD')} type="date" id="date_acquired"
                onChange={(e) => { props.handleDateAcquiredChange(inputFields); handleChangeInput(index, e) }} />
            </Col>

            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <br></br>
              <b>Gross Fair Market Value:</b>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input defaultValue={inputF.gfmv} type="number" id="gfmv"
                  onBlur={(e) => { props.handleGrossFairChange(inputFields); handleChangeInput(index, e) }}
                />
              </InputGroup>
            </Col>

          </Row>

          <Row>
            <Col xl={6} lg={6} md={12} sm={12}>
              <br></br>
              <b>Amount Debit:</b>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input defaultValue={inputF.aod} type="number" id="aod"
                  onBlur={(e) => { props.handleAmountDebitChange(inputFields); handleChangeInput(index, e) }} />
              </InputGroup>
            </Col>

            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <br></br>
              <b>Net Fair Market Value:</b>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input defaultValue={inputF.nfmv} type="number" id="nfmv"
                  onBlur={(e) => { props.handleNetFairChange(inputFields); handleChangeInput(index, e) }} />
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col>
              <br></br>
              <b>Proposal for Division Award or Confirm to:</b>
            </Col>

          </Row>
          <Row>
            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <b>Petitioner:</b>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input defaultValue={inputF.pfdp} type="number" id="pfdp"
                  onBlur={(e) => { props.handlePetitionerChange(inputFields); handleChangeInput(index, e) }} />
              </InputGroup>
            </Col>

            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <b>Respondent:</b>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input defaultValue={inputF.pfdr} type="number" id="pfdr"
                  onBlur={(e) => { props.handleRespondentChange(inputFields); handleChangeInput(index, e) }} />
              </InputGroup>
            </Col>
          </Row>
          <Row>


          </Row>

          <Row>
            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <IconButton onClick={() => {handleRemoveFields(index); deleteCall(inputF.form_160_asset_id, inputF.brief_desc, inputF.asset_brief_description_id)}} style={{ float: "right", color: "black", marginTop: "15px" }} >
                <RemoveIcon />
              </IconButton>

              {getButtonValue(props.descriptionId, size(inputFields)) && <IconButton disabled={false} onClick={(e) => {handleAddFields(); showModal(props.descriptionId, size(inputFields))}}
                style={{ float: "right", color: "black", marginTop: "15px" }}>
                <AddIcon id="addButtonDisable" />
              </IconButton>}
            </Col>
          </Row>
          <ColoredLine />
        </div>
      ))}
      <Modal isOpen={showNote} style={{ marginTop: "200px", marginLeft: "46%" }}>
        <ModalHeader>
        Note:
        </ModalHeader>
        <ModalBody> If you do not have the options to add more, the court form has run out
           of space. You will need to add a separate attachment. Watch your video tutorials
            for more details.
        </ModalBody>
        <ModalFooter>
        <Row style={{marginLeft:"3px"}}>
        <Button
          style={{width:"48%",marginRight:"2px", color: "white", backgroundColor: "Blue" }}
          onClick={handleCloseNote}
        >
          OK
        </Button>
        </Row>
        </ModalFooter>
      </Modal>
    </div>
  );
}


const mapDispatchToProps = (dispatch) => {
  return {
    successDescriptionOptionsData: () => dispatch(successDescriptionOptionsData()),
    deleteCommunityAssetsCall: (data) => dispatch(deleteCommunityAssetsCall(data)),
  }
}


const mapStateToProps = (state, ownProps) => ({
  descriptionOptions: state.communityPropertyReducer.descriptionOptions,
})

export default connect(mapStateToProps, mapDispatchToProps)(CommunityPropertySection);